import { put } from 'helpers/api';

export function save(companyPath, companyOffices) {
  const company = { companyOfficesAttributes: companyOffices };

  return put(companyPath, company);
}
